import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ResumeService } from '../../../../../../../UI/src/app/shared/resume/resume.service';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController } from 'ionic-angular';
import { ProfileService } from '../../../../../../../UI/src/app/shared/profile/profile.service';
import { ToastControllerService } from '../../../../../providers/toast-controller.service';
import { Toast508Service } from '../../../../../providers/toast-508.service';
import { SettingsService } from '../../../../../../../UI/src/app/shared/settings/settings.service';
import * as FileSaver from 'file-saver';


@Component({
  selector: 'page-attachments',
  templateUrl: 'attachments.component.html'
})
export class AttachmentsPageComponent implements OnInit {
  @Input() data: any;
  @Input() edit = false;
  @Input() attachOnly = false;
  @Output() update = new EventEmitter<any>();
  public videoFileUpload = false;
  public addNew = false;
  public addNewURL = false;
  public newFile = null;
  public newURL = null;
  public dataAttach = null;
  public dataURL = null;
  public translations: any;
  public loading;
  imgURL: any;
  private getFileSizeKey = 'ELIXHRUI_SUPPORTED_FILE_SIZE';
  public fileSizeSetting: any;
  private fileSizeExceedMessage: any;
  constructor(
    private settingsService: SettingsService,
    private toastService: ToastControllerService,
    public loadingCtrl: LoadingController,
    public resumeService: ResumeService,
    private profileService: ProfileService,
    private translate: TranslateService,
    private toast508Service: Toast508Service
  ) {
    this.translate.get(['CAREER_INVALID_DOCUMENT', 'CAREER_RESUME_FILE_SIZE', 'CAREER_RESUME_FILE_UPLOAD_MESSAGE'])
      .subscribe((obj) => {
        this.translations = obj;
      });
    this.loading = this.loadingCtrl.create({
      duration: 15000
    });
  }

  ngOnInit() {
    if (!this.edit) {
      this.getDataAndConfig();
    } else if (this.data) {
      this.populateValues();
    } else {
      //should not even reach here if data is missing.
      this.data = {
        attachments: []
      };
    }
    this.settingsService.GetSettings().subscribe(
      settings => {
        this.fileSizeSetting = settings.filter(setting => setting.key === this.getFileSizeKey)[0].value;
        this.fileSizeExceedMessage = this.translations['CAREER_RESUME_FILE_SIZE'].replace('{{limit}}', this.fileSizeSetting / (1024 * 1024));
      }
    );
  }

  saveNewFile() {
    const formData: FormData = new FormData();
    formData.append('DisplayName', this.newFile.name);
    formData.append('Description', this.newFile.description);
    formData.append('uploadFile', this.newFile.fileLocation);
    this.formDataUpload(formData);
  }

  saveNewUrl() {
    this.addNewURL = false;
    this.dataURL.unshift(this.newURL);
    this.sendUpdate();
  }

  fileChange(event: any) {
    if (event && event.target.files) {
      const fileList: FileList = event.target.files;
      if (fileList.length > 0) {
        const file = fileList[0];
        const filevalid = this.checkFileFormat(file.name, file.size);
        if (filevalid.sizeofFile && filevalid.typeofFile) {
          this.newFile.fileLocation = fileList[0];
          this.newFile.fileName = fileList[0].name;
          this.postVideoUploaded();
        } else {
          this.showFileUploadError(filevalid);
        }
        this.preview(file);
      }
    }
  }

  removeItem(item) {
    item.deleted = true;
    this.sendUpdate();
  }

  addItem() {
    if (!this.addNew) {
      this.newFile = {};
      this.addNew = true;
      this.imgURL = null;
    }
  }

  addURL() {
    if (!this.addNewURL) {
      this.newURL = {
        'attachmentType': 'URL'
      };
      this.addNewURL = true;
    }
  }

  private populateValues() {
    if (this.data.fieldDisplayType && this.data.fieldDisplayType == 'OBJECTIVE') {
      this.videoFileUpload = true;
      this.addItem();
      if (this.data.attachments) {
        this.newFile.fileName = this.data.attachments.length > 0 ? this.data.attachments[0].attachmentTitle : '';
      } else {
        this.data.attachments = [];
      }
      this.dataAttach = this.data.attachments;
    } else {
      this.addNew = false;
      if (this.data) {
        this.dataAttach = this.data.filter(a => a.attachmentType == "ATTACHMENT");
        this.dataURL = this.data.filter(a => a.attachmentType !== "ATTACHMENT");
      }
    }
  }

  private showFileUploadError(filevalid) {
    var alertData;
    if (!filevalid.typeofFile) {
      alertData = { message: this.translations['CAREER_INVALID_DOCUMENT'], type: 'error' };
    } else if (!filevalid.sizeofFile) {
      alertData = { message: this.fileSizeExceedMessage, type: 'error' };
    }
    this.toastService.presentToast(alertData);
    this.toast508Service.toFocus();
  }

  private postVideoUploaded() {
    if (this.videoFileUpload) {
      this.newFile.name = this.newFile.fileName;
      this.newFile.description = this.newFile.fileName;
      this.replaceOldFile();
    }
  }

  private replaceOldFile() {
    for (var i = 0; i < this.dataAttach.length; i++) {
      this.dataAttach[i].deleted = true;
    }
    this.saveNewFile();
  }

  private pushNewFile() {
    //reset UI for accepting new files
    this.addNew = false;
    var file = {
      fileAssetId: this.newFile.id,
      fileName: this.newFile.fileName,
      attachmentType: "ATTACHMENT",
      deleted: false,
      attachmentSummary: this.newFile.description,
      attachmentTitle: this.newFile.name
    };
    this.dataAttach.unshift(file);
    var alertData = { message: this.translations['CAREER_RESUME_FILE_UPLOAD_MESSAGE'], type: 'success' };
    this.toastService.presentToast(alertData);
    this.toast508Service.toFocus();
    this.sendUpdate();
  }

  private formDataUpload(formData) {
    this.loading.present();
    this.profileService.uploadFile(formData).subscribe(
      (response) => {
        this.loading.dismiss();
        var fileDets = JSON.parse(response.returnData)
        this.newFile.id = fileDets.id;
        this.newFile.fileName = fileDets.fileName;
        this.pushNewFile();
      }, (error) => {
        this.loading.dismiss();
        console.log("file uploaded failed", error);
      }
    );
  }

  private checkFileFormat(name, size) {
    const docFileParams = {
      fileSize: this.fileSizeSetting,
      fileType: ['image/*', 'audio/*', 'video/*', 'text/plain', '.doc', '.docm', '.docx', '.xls', '.xlsm', '.xlsx',
        '.oda', '.odc', '.odh', '.odl', '.odp', '.ods', '.odt', '.7z', '.zip', '.rar', '.png', '.gif', '.jpg', '.jpeg',
        '.js', '.css', '.htm', '.html', '.mpg', '.mp4', '.mpeg', '.avi', '.mov', '.mp3', '.wmv', '.pdf', '.txt'],
      videoType: ['video/*', '.mpg', '.mp4', '.mpeg', '.avi', '.mov', '.mp3', '.wmv']
    };
    const fileParams = {
      typeofFile: false,
      sizeofFile: false
    };
    this.newFile.name = name;
    const fileTypes = this.videoFileUpload ? docFileParams.videoType : docFileParams.fileType
    if (fileTypes.indexOf(name.substring(name.lastIndexOf('.')).toLowerCase()) !== -1) {
      fileParams.typeofFile = true;
      if (size <= docFileParams.fileSize) {
        fileParams.sizeofFile = true;
      }
      return fileParams;
    } else {
      return fileParams;
    }
  }

  private sendUpdate() {
    this.update.emit({
      attachments: this.dataAttach.concat(this.dataURL)
    });
  }

  private getDataAndConfig() {
    this.data = this.resumeService.getResumeValue('attachments');
  }

  downLoadAttachment(attachment) {
    this.profileService.downloadFile(attachment.fileAssetId).subscribe(
      (res) => {
        FileSaver.saveAs(res, attachment.fileName);
      }
    );
  }

  preview(file) {
    const mimeType = file.type;
    if (mimeType.match(/image\/*/) == null) {
      this.imgURL = null;
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (_event) => {
      this.imgURL = reader.result;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/modules/edit-profile/resume/attachments/attachments.component.ts